import SupportedBrowsers from './supportedBrowsers';

export default SupportedBrowsers;